// Campus photo for /colleges/berklee-college-of-music: CC BY 4.0, by ajay_suresh, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABerklee_College_of_Music_(54954487634).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/berklee-college-of-music/; credited under the photo.
const photo = {
    "slug": "berklee-college-of-music",
    "alt": "Berklee College of Music buildings at Massachusetts Avenue and Boylston Street in Boston, with the Back Bay skyline behind",
    "src": "/colleges/berklee-college-of-music/campus-1600.webp",
    "srcSmall": "/colleges/berklee-college-of-music/campus-800.webp",
    "srcMid": "/colleges/berklee-college-of-music/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/berklee-college-of-music/og.jpg",
    "title": "Berklee College of Music (54954487634)",
    "author": "ajay_suresh",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABerklee_College_of_Music_(54954487634).jpg",
    "read": "2026-10-01"
};

export default photo;
